import { queryStringToParameters, urlData, removeSpecificQueryStrings } from './urlUtils';
import { getMGMToETL } from './mgmUtils';
import { getActiveExperimentsData } from './figpii/getActiveExperimentsData';

const INITIAL_QUERY_STRING_KEY = 'initialQueryString';
const KEYS_TO_REMOVE = ['cpf', 'email'];

function removeKeys(object, keys) {
  const updatedObject = { ...object };
  keys.forEach(key => {
    delete updatedObject[key];
  });

  return updatedObject;
}

function getQueryStringFromLocalStorage() {
  let initialQueryString = sessionStorage.getItem(INITIAL_QUERY_STRING_KEY);
  if (!initialQueryString) {
    initialQueryString = JSON.stringify(window.location);
    sessionStorage.setItem(INITIAL_QUERY_STRING_KEY, initialQueryString);
  }

  const initialQuery = JSON.parse(initialQueryString);

  return {
    ...initialQuery,
    search: initialQuery.search || '',
  };
}

export function getMarketingParameters() {
  const { location } = document;
  const queryString = getQueryStringFromLocalStorage();
  const marketingParameters = queryStringToParameters(queryString.search);
  const updatedMarketingParameters = removeKeys(marketingParameters, KEYS_TO_REMOVE);
  const landingUrl = removeSpecificQueryStrings(queryString.href || location.href, KEYS_TO_REMOVE);
  return {
    ...updatedMarketingParameters,
    landing_url: landingUrl,
  };
}

export function getMarketingData({ additionalParameters = {} } = {}) {
  const { referrer } = document;
  const referrerHost = urlData(referrer).host;
  const marketingParameters = getMarketingParameters();
  const activeExperiments = getActiveExperimentsData();
  const cleanCurrentUrl = removeSpecificQueryStrings(window.location.href, KEYS_TO_REMOVE);

  const parameters = {
    ...marketingParameters,
    ...getMGMToETL({
      hasReferralIdOnURL: marketingParameters.id,
    }),
    current_url: cleanCurrentUrl,
    version: '5.0.0',
    project: 'www',
    experiments: activeExperiments,
    ...additionalParameters,
  };

  const differentHost = referrerHost !== document.location.host;
  const result = {};

  if (differentHost) {
    result.referrer = referrerHost;
  }

  if (parameters.utm_source) {
    result.network = parameters.utm_source;
  }

  result.parameters = JSON.stringify(parameters);
  return result;
}

export function persistMarketingURL(documentLocation = {}) {
  sessionStorage.setItem(
    INITIAL_QUERY_STRING_KEY,
    JSON.stringify(documentLocation),
  );
}
